import { useCallback } from 'react';
import type { AlertColor } from '@mui/material/Alert';
import { useSnackbar, type VariantType } from 'notistack';

export type AppSnackbarShowOptions = {
  message: string;
  severity?: AlertColor;
  autoHideDuration?: number;
};

function severityToVariant(severity: AlertColor | undefined): VariantType {
  if (severity === 'success' || severity === 'error' || severity === 'warning' || severity === 'info') {
    return severity;
  }
  return 'info';
}

/**
 * notistack のラッパー
 * 高度な指定は enqueueSnackbar / closeSnackbar をそのまま使える
 */
export function useAppSnackbar() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showSnackbar = useCallback(
    (options: AppSnackbarShowOptions) => {
      enqueueSnackbar(options.message, {
        variant: severityToVariant(options.severity),
        autoHideDuration: options.autoHideDuration ?? 5000,
      });
    },
    [enqueueSnackbar]
  );

  return { showSnackbar, enqueueSnackbar, closeSnackbar };
}
